import camelCase from 'lodash/camelCase'

export const formatContentfulClasses = (
  contentfulClasses: string[] | null
): string[] => {
  if (!contentfulClasses) return []
  return contentfulClasses.map(
    (contentfulClass: string) => `contentful-class-${contentfulClass}`
  )
}

export default formatContentfulClasses

// @TODO: We'd not need this once we implement the Contentful styling solution
export const getModuleClasses = (
  contentfulClasses: string[] | null,
  module: Record<string, string>
): string[] => {
  if (!contentfulClasses) {
    return []
  }

  return contentfulClasses.map(
    (contentfulClass) => module[camelCase(contentfulClass)]
  )
}
